import React from "react";
import HomePageV2 from "./main-page-v2/index";

const IndexPage = (props) => {
  return (
    <HomePageV2 />
  );
};
export default IndexPage;
